import React, { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import { useNavigate } from 'react-router-dom';
import { forwardRef } from 'react';
import { useImperativeHandle } from 'react';
import { Grid, Box, MenuItem, Card, CardContent, Stack, InputAdornment, IconButton } from '@mui/material';

import ApiService from '../../../../services/ApiService';
import LoadingSpinner from '../../../../components/Components/LoadingSpinner';
import ModalConfirmation from '../../../../components/Modals/ModalConfirmation';
import ButtonContributionOfSalesCostView from './Buttons/ButtonContributionOfSalesCostView';
import SelectDataContact from './Selects/SelectDataContact';
import HeaderInfo from '../../../../components/Components/HeaderInfo';
import CustomToastContainer, { CustomDatePicker, Icon, Input, Selection, showToast } from '../../../../components/ui';
import { encryptFunction, PrintPDF } from '../../../../utils/reusableFunction';

const ContributionOfSalesCostView = forwardRef((props, ref) => {
    const [isLoadingBackDrop, setIsLoadingBackDrop] = useState(true);
    const history = useNavigate();
    const paramRegUserAccess = 'regUserAccess/regUserAccess';
    const [DataRegUserAccess, setDataRegUserAccess] = useState([]);

    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [contactTypeId, setContactTypeId] = useState(2);
    const [isAll, setIsAll] = useState(true);
    const [contactId, setContactId] = useState(0);
    const [contactCode, setContactCode] = useState('');
    const [contactName, setContactName] = useState('');
    const ContactTypeData = [
        { id: 1, code: 2, name: 'Shipper' },
        { id: 2, code: 3, name: 'Consignee' },
        { id: 3, code: 1, name: 'Agent' },
    ];
    const CustomCustomerList = [
        { id: 1, code: true, name: 'All' },
        { id: 2, code: false, name: 'Custom' },
    ];

    const paramC = 'regContact/regContact';
    const [isLoadingC, setIsLoadingC] = useState(false);
    const [isModalC, setIsModalC] = useState(false);
    const [dataC, setDataC] = useState([]);
    const [titleModalC, setTitleModalC] = useState('');
    const [columnDataC, setColumnDataC] = useState([]);
    const [SelectedDataC, setSelectedDataC] = useState({});
    const [totalRowsC, setTotalRowsC] = useState(50);
    const [dataMapC, setDataMapC] = useState([]);

    const [isModalConfirmation, setIsModalConfirmation] = useState(false);
    const [titleModalConfirmation, setTitleModalConfirmation] = useState('');
    const [titleConfirmation, setTitleConfirmation] = useState('');

    const BreadcrumbsItems = [
        { label: 'Majura', link: '/Majura', style: '' },
        { label: 'Contribution Of Sales Cost', link: '/Majura/ContributionOfSalesCostReport', style: { color: '#0087C2', fontWeight: '700' } },
    ];

    useImperativeHandle(ref, () => ({
        localSave() {

        }
    }));

    useEffect(() => {
        document.title = 'Contribution Of Sales Cost - ' + JSON.parse(localStorage.getItem('branchName'));
        getDataAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getDataAccess = () => {
        setIsLoadingBackDrop(true);
        let params = [];
        let pId = 0;
        let listMenu = JSON.parse(localStorage.getItem("dataMenuCode")) || [];
        let hasAccess = false

        const indexMenu = listMenu.findIndex((elm) => elm.code === 'OSHOR')
        if (indexMenu !== -1) {
            pId = listMenu[indexMenu].id
            hasAccess = true
        }

        if (hasAccess) {
            params = [
                ...params,
                { 'attr': 'permissionId', 'value': '' + pId },
                { 'attr': 'userId', 'value': '' + JSON.parse(localStorage.getItem("userId")) },
                { 'attr': 'roleId', 'value': '' + JSON.parse(localStorage.getItem("roleId")) }
            ]
            ApiService.IdentityPostByPage(paramRegUserAccess, 'PAGE', 1, 100, params, [])
                .then((response) => {
                    if (response.data.code === 200) {
                        setDataRegUserAccess(response.data.data.userAccess);

                        getDateNow();
                    }
                })
                .catch(function (error) {
                    console.error('error saat fetch', error)
                    history('/Majura');
                })
        }
        else {
            history('/Majura');
        }
    }

    const handleClickConfirmation = () => {
        if (isModalConfirmation === false) {
            setIsModalConfirmation(true);
        }
        else {
            setIsModalConfirmation(false);
        }
    }

    function ConfirmationCOSC() {
        if (titleConfirmation === 'Print') {
            PrintReport();
        }
        setIsModalConfirmation(false);
    }

    const checkInput = () => {
        let check = 0;

        if (isAll === false && contactCode === '') {
            check = 1;
        }

        if (check === 1) {
            showToast({ type: 'error', message: 'Please Select Data Customer!' })
        }

        return check;
    }

    const PrintData = () => {
        if (checkInput() === 0) {
            setTitleConfirmation('Print')
            setTitleModalConfirmation('Contribution Of Sales Cost');
            handleClickConfirmation();
        }
    };

    const PrintExcel = () => {
        if (checkInput() === 0) {
            setTitleConfirmation('Print Excel')
            setTitleModalConfirmation('Contribution Of Sales Cost');
            handleClickConfirmation();
        }
    };

    function PrintReport() {
        setIsLoadingBackDrop(true);

        let params = [
            {
                "attr": "StartDate",
                "value": '' + dateFrom
            },
            {
                "attr": "EndDate",
                "value": '' + dateTo
            },
            {
                "attr": "CustomerTypeId",
                "value": '' + contactTypeId
            },
            {
                "attr": "CustomerId",
                "value": '' + contactId
            }
        ]

        let reportLink = 'Reports/Finance/Print/ControlReport/ContributionSalesCostReport/ContributionSalesCostReport/PrintContributionSalesCost?payloads=' + encryptFunction(params);
        PrintPDF(setIsLoadingBackDrop, 'Contribution of Sales Cost', reportLink);
    }

    function getDateNow() {
        setIsLoadingBackDrop(false);
        let dateNow = new Date()
        var formatDateNow = dateNow.toLocaleDateString("sv-se").split('T')[0];
        setDateFrom(formatDateNow);
        setDateTo(formatDateNow);
    }

    function handleDate(source, value) {
        if (source === 'From') {
            if (value > dateTo) {
                showToast({ type: 'error', message: 'Date From Can\'t Be Greater Than Date To' });
            }
            else {
                setDateFrom(value);
            }
        }
        else {
            if (value < dateFrom) {
                showToast({ type: 'error', message: 'Date To Can\'t Be Smaller Than Date From' });
            }
            else {
                setDateTo(value);
            }
        }
    }

    function handleContactTypeId(value) {
        setContactTypeId(value);
        EmptyContact();
    }

    function handleIsAll(value) {
        setIsAll(value);
        EmptyContact();
    }

    function EmptyContact() {
        setContactId(0);
        setContactCode('');
        setContactName('');
    }

    const handleClickContact = () => {
        setTitleModalC('Contact');
        if (isModalC === false) {
            getDataContact(1, 50);
            setIsModalC(true);
        }
        else {
            setIsModalC(false);
        }
    }

    const getDataContact = (pageNumber, pageSize, filters, orderBy) => {
        setIsLoadingC(true)
        const params = [{ 'attr': "contactTypeId", 'value': '' + contactTypeId }];
        ApiService.DynamicPostByPage(paramC, 'SEARCH', pageNumber, pageSize, params, filters, orderBy)
            .then((response) => {
                if (response.data.code === 200) {
                    setSelectedDataC({})
                    setDataC(response.data.data.contact);
                    let temp = response.data.data.contact
                    let indexed = temp.map((el, index) => {
                        let indexedTemp = {
                            ...el,
                            index
                        }
                        return indexedTemp
                    })

                    setDataMapC(indexed)
                    setColumnDataC(response.data.data.columns)
                    setTotalRowsC(response.data.totalRowCount)
                    setIsLoadingC(false)
                }
            })
            .catch(function (error) {
                console.error('error saat fetch', error)
                setIsLoadingC(false)
            })
    }

    const ButtonComponents = () => {
        return (
            <ButtonContributionOfSalesCostView
                PrintData={PrintData}
                PrintExcel={PrintExcel}
                DataRegUserAccess={DataRegUserAccess}
            />
        )
    }

    return (
        <Box className='w-100' sx={{ width: '100%', p: 3 }}>
            <CustomToastContainer />
            <Grid container spacing={0} direction="column">
                <HeaderInfo
                    title={'Contribution Of Sales Cost'}
                    isJobType={false}
                    BreadcrumbsItems={BreadcrumbsItems}
                    ButtonComponents={ButtonComponents}
                />

                <Grid item xs={12} style={{ 'width': '100%', 'borderRadius': '5px' }}>
                    <div style={{ marginTop: '24px' }}>
                        <Grid
                            container
                            spacing={'32px'}
                        >
                            <Grid
                                item
                                xl={6}
                                lg={6}
                                sm={6}
                                xs={12}
                            >
                                <Card component="div" style={{ borderRadius: '12px', backgroundColor: '#F2F2F2', padding: '16px 24px' }}>
                                    <CardContent>
                                        <Grid
                                            container
                                            spacing={'16px'}
                                        >
                                            <Grid
                                                item
                                                xl={6}
                                                lg={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <CustomDatePicker
                                                    type='date'
                                                    value={dateFrom}
                                                    label="Date From"
                                                    onChange={(e) => handleDate('From', e)}
                                                    formControlProps={{ sx: { width: '100%' } }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xl={6}
                                                lg={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <CustomDatePicker
                                                    type='date'
                                                    value={dateTo}
                                                    label="Date To"
                                                    onChange={(e) => handleDate('To', e)}
                                                    formControlProps={{ sx: { width: '100%' } }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid
                                item
                                xl={6}
                                lg={6}
                                sm={6}
                                xs={12}
                            >
                                <Card component="div" style={{ borderRadius: '12px', backgroundColor: '#F2F2F2', padding: '16px 24px' }}>
                                    <CardContent>
                                        <Grid
                                            container
                                            spacing={'16px'}
                                        >
                                            <Grid
                                                item
                                                xl={6}
                                                lg={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <Selection
                                                    id='0'
                                                    value={contactTypeId}
                                                    fullWidth={true}
                                                    label={'Customer Type'}
                                                    placeholder={'Select Customer Type'}
                                                    onChange={(e) => handleContactTypeId(e.target.value)}
                                                >
                                                    {
                                                        ContactTypeData.map((data) => (
                                                            <MenuItem sx={{ fontSize: '12px' }} id={data.id} key={data.id} value={data.code}>
                                                                {data.name}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </Selection>
                                            </Grid>

                                            <Grid
                                                item
                                                xl={6}
                                                lg={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <Selection
                                                    id='0'
                                                    value={isAll}
                                                    fullWidth={true}
                                                    label={'Custom Customer'}
                                                    placeholder={'Select Custom Customer'}
                                                    onChange={(e) => handleIsAll(e.target.value)}
                                                >
                                                    {
                                                        CustomCustomerList.map((data) => (
                                                            <MenuItem sx={{ fontSize: '12px' }} id={data.id} key={data.id} value={data.code}>
                                                                {data.name}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </Selection>
                                            </Grid>
                                        </Grid>

                                        <Stack spacing={'16px'} direction="row" sx={{ marginTop: '16px !important' }}>
                                            <Input
                                                readOnly
                                                disabled
                                                value={contactCode}
                                                label="Customer Code"
                                            />

                                            <Input
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth
                                                disabled
                                                value={contactName}
                                                label="Customer Name"
                                                type='text'
                                                formControlProps={{
                                                    sx: {
                                                        width: '100%',
                                                    }
                                                }}
                                                inputBaseProps={{
                                                    readOnly: true,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={() => EmptyContact()}
                                                                hidden={contactName ? false : true}
                                                            >
                                                                <Icon
                                                                    iconName={'close'}
                                                                    svgIconProps={{
                                                                        fontSize: 'small',
                                                                        htmlColor: '#0087C2',
                                                                        sx: {
                                                                            height: '12px',
                                                                            width: '12px'
                                                                        }
                                                                    }}
                                                                />
                                                            </IconButton>

                                                            <IconButton
                                                                onClick={() => handleClickContact()}
                                                                hidden={isAll}
                                                            >
                                                                <Icon
                                                                    iconName={'search'}
                                                                    svgIconProps={{
                                                                        fontSize: 'small',
                                                                        htmlColor: '#0087C2',
                                                                        sx: {
                                                                            height: '12px',
                                                                            width: '12px'
                                                                        }
                                                                    }}
                                                                />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>

            {
                isLoadingBackDrop && (
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={isLoadingBackDrop}
                    >
                        <LoadingSpinner />
                    </Backdrop>
                )
            }

            {
                isModalC && (
                    <SelectDataContact
                        isModal={isModalC}
                        titleModal={titleModalC}
                        handleClick={handleClickContact}
                        isLoading={isLoadingC}
                        data={dataC}
                        getData={getDataContact}
                        columnData={columnDataC}
                        dataMap={dataMapC}
                        totalRows={totalRowsC}
                        SelectedData={SelectedDataC}
                        setSelectedData={setSelectedDataC}

                        setContactId={setContactId}
                        setContactCode={setContactCode}
                        setContactName={setContactName}
                    />
                )
            }

            {
                isModalConfirmation && (
                    <ModalConfirmation
                        isModal={isModalConfirmation}
                        titleModal={titleModalConfirmation}
                        title={titleConfirmation}
                        handleClick={handleClickConfirmation}
                        ConfirmationData={ConfirmationCOSC}
                    />
                )
            }
        </Box>
    )
})

export default ContributionOfSalesCostView